module.exports = __webpack_public_path__ + "static/media/simples_assim_logo.0b87160f.png";